/** Formats a raw phone digit string (optionally with a leading country code) for display, e.g. "18001234567" -> "1-800-123-4567". */
export function formatPhoneDisplay(rawPhoneValue: string): string {
  const match = rawPhoneValue.match(/^(\D*)([\d\s().+-]+)(.*)$/);
  if (!match) {
    return rawPhoneValue;
  }
  const [, prefix, phoneLikePart, suffix] = match;
  const digits = phoneLikePart.replace(/\D/g, '');
  const trailingSeparator = phoneLikePart.match(/[^0-9]*$/)?.[0] ?? '';
  const hasCountryCode = digits.length >= 11 && digits.slice(-11, -10) === '1';
  const digitCount = hasCountryCode ? 11 : 10;

  if (digits.length >= digitCount) {
    const phoneDigits = digits.slice(-digitCount);
    if (phoneDigits.length === 11) {
      return `${prefix}${phoneDigits[0]}-${phoneDigits.slice(
        1,
        4
      )}-${phoneDigits.slice(4, 7)}-${phoneDigits.slice(
        7
      )}${trailingSeparator}${suffix}`;
    }
    return `${prefix}${phoneDigits.slice(0, 3)}-${phoneDigits.slice(
      3,
      6
    )}-${phoneDigits.slice(6)}${trailingSeparator}${suffix}`;
  }
  return rawPhoneValue;
}

/** Converts a raw phone value to a `tel:` href, stripping everything but digits and a leading "+". */
export function toTelHref(rawPhoneValue: string): string {
  const telValue = rawPhoneValue.replace(/[^\d+]/g, '');
  return `tel:${telValue}`;
}
